import { Component, OnInit } from '@angular/core';
import { AppService } from './app.service';
import { AzureAppInsightsService } from './common-services/appinsights.azure.service';


@Component({
  selector: 'app-root',
  template: `
    <app-header></app-header>
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.css']  
})
export class AppComponent implements OnInit {
  
  constructor(private appService: AppService, private azureAppInsightsService : AzureAppInsightsService){}
  
  ngOnInit(): void {
    this.appService.refreshFeatures() 
  }


}
